import { classes } from './utils';

export type ListItemProps = {
  label: string;
  subtitle: string;
  onClick: () => void;
};

export default function ListItem({ label, subtitle, onClick }: ListItemProps) {
  return (
    <div className={classes.item} onClick={onClick}>
      <span className={classes.label}>{label}</span>
      <span className={classes.subtitle}>{subtitle}</span>
    </div>
  );
}
